// Lib
import React from 'react';
import { useSelector } from 'react-redux';

// Selectors
import { getPlatformDetailsSelector } from '../platform/platformSelector';

// Types
import { PlatformType } from '../../common/platform/platformTypes';

/**
 * For a reason that I couldn't determine - a double click handler was required on the
 * document when running on an *iPad* - otherwise all double click handlers (canvas
 * and element container) won't work.
 *
 * NOTE: This is only after the React 17 upgrade and only on iPads, not iPhones.
 */
const useIpadDoubleTapFix = () => {
    const platformDetails = useSelector(getPlatformDetailsSelector);

    React.useEffect(() => {
        if (platformDetails.type !== PlatformType.ipad) return;

        // Noop
        const onDocDoubleClick = () => {};

        document.addEventListener('dblclick', onDocDoubleClick);

        return () => {
            document.removeEventListener('dblclick', onDocDoubleClick);
        };
    }, [platformDetails]);
};

export default useIpadDoubleTapFix;
